import React from 'react'
import MoreButton from './MoreButton'
import AspectRatioBox from '../../../components/AspectRatioBox/ApectRatioBox'
import { Link } from 'react-router-dom'
import PlayButton from './PlayButton'

type Props = {
  name: string
  description: string
  video: {
    thumbnailUrl: string
  }
}
export default function NutritionStartNutritionTime({
  name,
  description,
  video,
}: Props) {
  return (
    <div className="px-20 lg:px-48 max-w-480 mx-auto">
      <div className="group relative flex flex-col mb-24 lg:mb-32 rounded-16 lg:shadow-elevated lg:bg-Bg lg:border-1 border-Border">
        <AspectRatioBox ratio={0.55}>
          <img
            src={video.thumbnailUrl}
            alt=""
            className="w-full rounded-6 lg:rounded-t-16 lg:rounded-b-none  object-cover"
          />
          <div
            className="bg-black absolute inset-0 rounded-6 lg:rounded-t-16 lg:rounded-b-none"
            style={{ opacity: 0.15 }}
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <PlayButton />
          </div>
        </AspectRatioBox>
        <div className="flex flex-col text-left pt-16 lg:px-24 lg:py-20">
          <h3 className="mb-6 lg:mb-12">
            <Link
              to="/nutrition-explained/videos/"
              className="fill-link text-Type"
            >
              <span className="block text-green type-upper-fat mb-4">
                Episode 1
              </span>
              <span className="sr-only">{': '}</span>
              <span className="type-20-demibold lg:type-24-bold transition border-b-3 border-transparent group-hover:border-Brand capitalize">
                {name}
              </span>
            </Link>
          </h3>
          <p className="leading-body">{description}</p>
        </div>
      </div>
      <MoreButton
        use={Link}
        to="/nutrition-explained/videos/#episodes"
        className="mb-48 lg:mb-0"
      >
        All episodes
      </MoreButton>
    </div>
  )
}
